/* WizardTreeViewRenderer.js */

"use strict";
const EntityTreeGrid = require("@gluenetworks/steve_ui_entity_widgets").Grid.EntityTreeGrid;
const Grid = EntityTreeGrid.Grid;
const DefaultColumnDefinition = EntityTreeGrid.DefaultColumnComponent;
const TagsColumnComponent = require("./columnrenderers/tags/TagsColumnComponent");
const _ = require("lodash");

class WizardTreeViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("wizard-tree-view-gl");
        this._rootElem.component = this._model;

        this._grid = new Grid({
            columns: {
                displayName: {
                    label: "Name",
                    columnRendererComponent: DefaultColumnDefinition,
                    sortable: false,
                    width: 0.3
                },
                shortDescription: {
                    label: "Description",
                    columnRendererComponent: DefaultColumnDefinition,
                    sortable: false,
                    width: 0.5
                },
                tags: {
                    label: "Tags",
                    columnRendererComponent: TagsColumnComponent,
                    sortable: false,
                    width: 0.2
                }
            },
            //columnOrder: ['displayName', 'description', 'tags'],
            changeFeed: this._model.wizardFeed,
            singleSelect: true
        });

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.on("WizardsInitialized", (this._onWizardsInitialized = this._onWizardsInitialized.bind(this)));
        this._model.on("WizardAdded", (this._onWizardAdded = this._onWizardAdded.bind(this)));
        this._model.on("WizardRemoved", (this._onWizardRemoved = this._onWizardRemoved.bind(this)));
        this._model.on("WizardUpdated", (this._onWizardUpdated = this._onWizardUpdated.bind(this)));
        this._grid.on("GridAction", (this._onGridAction = this._onGridAction.bind(this)));
        this._grid.on("UserRowDoubleClicked", (this._onGridUserRowDoubleClicked = this._onGridUserRowDoubleClicked.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("WizardsInitialized", this._onWizardsInitialized);
        this._model.removeListener("WizardAdded", this._onWizardAdded);
        this._model.removeListener("WizardRemoved", this._onWizardRemoved);
        this._model.removeListener("WizardUpdated", this._onWizardUpdated);
        this._grid.removeListener("GridAction", this._onGridAction);
        this._grid.removeListener("UserRowDoubleClicked", this._onGridUserRowDoubleClicked);
    }

    _showDefaultMessageDisplay() {
        return this._model.gameEditor
            .showDefaultMessageView({
                message: "No workflows available"
            })
            .then(() => {
                this._defaultViewActive = true;
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "WorkTrigGridViewRenderer._showDefaultMessageDisplay error");
            });
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor
            .hideDefaultMessageView()
            .then(() => {
                this._defaultViewActive = false;
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "WorkTrigGridViewRenderer._hideDefaultMessageDisplay error");
            });
    }

    _onFeedRefreshView() {
        const totalEntities = _.size(this._model._wizardFeed.cache);

        if (totalEntities === 0) {
            this._showDefaultMessageDisplay();
        } else {
            this._hideDefaultMessageDisplay();
        }
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];
        promArr.push(this._grid.shutdown());

        return Promise.all(promArr).then(() => {
            //TODO set all class members to undefined here
            this._model = undefined;
            this._grid = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
        });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._rootElem.innerHTML = "";
        if (!_.isUndefined(this._grid)) {
            this._rootElem.appendChild(this._grid.renderer.rootElement);
        }
        this._onFeedRefreshView(); //default message added
        return Promise.resolve();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onWizardsInitialized() {
        this.render();
    }
    _onWizardAdded(/*whiz*/) {
        this._onFeedRefreshView();
    }
    _onWizardRemoved(/*whiz*/) {
        this._onFeedRefreshView();
    }
    _onWizardUpdated(/*whiz*/) {
        this._onFeedRefreshView();
    }
    _onGridAction(/*eventData*/) {
        //console.info('GRID ACTION', eventData);
    }
    _onGridUserRowDoubleClicked(selectedRow) {
        this._model.launchWizardInstanceEditor(selectedRow);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = WizardTreeViewRenderer;
